import React from 'react';
import { Typography } from '@mui/material';
import GridContainer from 'components/shared/GridContainer';
import GridItem from 'components/shared/GridItem';
import Card from 'components/shared/Card';
import { ApprovalLevel } from 'store/types/Meeting';

interface ApprovalLevelViewCardProps {
  approvalLevel: ApprovalLevel;
}

const ApprovalLevelViewCard: React.FunctionComponent<ApprovalLevelViewCardProps> = ({ approvalLevel }) => {
  return (
    <Card title={<Typography variant="h6">Approval Level</Typography>} bordered>
      <GridContainer spacing={1}>
        <GridItem>
          <Typography>{approvalLevel.statement}</Typography>
        </GridItem>
      </GridContainer>
    </Card>
  );
};

export default ApprovalLevelViewCard;
